<template>
    <div class="container-fluid">
      <div class="row pt-2 text-start mb-2">
          <div class="col-8">
              <h5>
                  <span class="badge rounded-pill text-dark p-2 px-3" style="background:LightBlue">
                  <b>Clinic Remote : กำหนด user/password สำหรับการเข้าถึงผลแล็บของคลินิกต้นทาง</b>
                  </span>
              </h5>
          </div>
          <div class="col">
          </div>
      </div>
      <div class="row ">
        <div class="col-sm-8">
            <table id="myClinicTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <th>รหัส</th>
                    <th>ชื่อหน่วยงาน/บริษัท</th>
                    <th style="width: 250px;">ที่อยู่</th>
                    <th>โทรศัพท์</th>
                    <th>Remote User</th>
                    <th style="width: 120px;">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.reqclinicid" v-bind:data-id="item.reqclinicid" @click="tableChanged(item)">
                    <td class="text-start">{{ item.ReqClinicCode }}</td>
                    <td class="text-start">{{ item.ReqClinicName }}</td>
                    <td class="text-start">{{ item.Addr1 }} {{ item.Amphor }} {{ item.Tambon }} {{ item.Province }}</td>
                    <td class="text-start">{{ item.Tel1 }} {{ item.Tel2 }}</td>
                    <td class="text-start text-success"> <b> {{ item.ClinicUsername }} </b></td>
                    <td  >
                      <button class="btn btn-danger btn-sm me-1" id="ResetPwd" @click="ResetPassword(item)" title="รีเซตรหัสผ่านเป็นค่าเริ่มต้น">Reset</button>
                      <button class="btn btn-warning btn-sm " id="ChangePwd" title="เปลี่ยนรหัสผ่าน" data-bs-toggle="modal" data-bs-target="#exampleModal">Change</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Change Password</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="row mb-2">
                            <div class="col-2"></div>
                            <div class="col">
                                <label for="inputPassword" class="visually-hidden">Password</label>
                                <input type="password" class="form-control" id="inputPassword" ref="inputPassword" placeholder="ป้อนรหัสผ่าน" v-model="pwd">
                            </div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-2"></div>
                            <div class="col">
                                <label for="inputPassword2" class="visually-hidden">Password (Repeat)</label>
                                <input type="password" class="form-control" id="inputPassword2" ref="inputPassword2" placeholder="ป้อนรหัสผ่านอีกครั้ง" v-model="pwd2">
                            </div>
                            <div class="col-2"></div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" ref="btnCloseModal">Close</button>
                    <button type="button" class="btn btn-primary" @click="ChangePassword()">Change Password</button>
                </div>
                </div>
            </div>
        </div>

      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'ClinicReq',
  components: {

  },
  data () {
    return {
      pwd: '',
      pwd2: '',

      datalists: null,
      curRecord: {},
      action: 'new'
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    ChangePassword (item) {
      var self = this
      if (this.pwd.trim().length < 4 || this.pwd2.trim().length < 4) {
        this.$refs.inputPassword.focus()
        Swal.fire({ icon: 'error', text: 'ต้องป้อนรหัสผ่านความยาวอย่างน้อย 4 ตัว ' })
      } else if (this.pwd.trim() !== this.pwd2.trim()) {
        this.$refs.inputPassword2.focus()
        Swal.fire({ icon: 'error', text: 'รหัสผ่านไม่ตรงกัน ' })
      } else {
        $.ajax({
          type: 'POST',
          url: this.http_baseurl + 'setdata/clinicuser_change.php',
          data: { id: this.curRecord.ReqClinicID, Password: this.pwd }
        }).done(function () {
          var elem = self.$refs.btnCloseModal
          elem.click()
          Swal.fire({
            text: 'เปลี่ยนรหัสผ่านเรียบร้อย..แจ้ง Remote User ให้เปลี่ยนรหัสผ่านอีกครั้งทันที',
            icon: 'success',
            confirmButtonText: 'ตกลง'
          }).then((result) => {
            self.getData()
          })
        })
      }
    },
    ResetPassword (item) {
      var self = this
      Swal.fire({
        title: item.Username,
        text: 'คุณแน่ใจหรือไม่...ที่จะรีเซตรหัสผ่าน? \n รหัสผ่านจะรีเซตเป็นชื่อผู้ใช้งาน (Remote User)',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/clinicuser_reset.php',
            data: { id: item.ReqClinicID, ClinicUsername: item.ClinicUsername }
          }).done(function () {
            Swal.fire({
              text: 'รีเซตรหัสผ่านเรียบร้อย..แจ้ง Remote User ให้เปลี่ยนรหัสผ่านทันที',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              self.getData()
            })
          })
        }
      })
    },
    tableChanged (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)
    },
    getData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/clinicreq_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          setTimeout(function () { $('#myClinicTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
